module.exports = __webpack_public_path__ + "static/img/monthButton.50580f8.png";